module.exports = __webpack_public_path__ + "img/baby_phoenix.b5be4425.jpg";